import { KeyframeConfig } from "../../../models/animations.model";

const REVEAL_OFFSET_BUFFER = -16;

export const getRevealInLeftBaseKeyframe = (
  clipPathleft: number,
  width: number,
  objectleft: number,
  opacity: number,
  fabricObject: any,
  scaleX: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: clipPathleft + width,
          },
          {
            left: clipPathleft,
          },
        ],
      },
      offset: REVEAL_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            left: objectleft - width * scaleX,
            opacity: 0,
          },
          {
            left: objectleft,
            opacity: opacity,
          },
        ],
      },
    },
  ];
};

export const getRevealInRightBaseKeyframe = (
  width: number,
  objectleft: number,
  opacity: number,
  fabricObject: any,
  scaleX: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: fabricObject.clipPath.left - width,
          },
          {
            left: fabricObject.clipPath.left,
          },
        ],
      },
      offset: REVEAL_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            left: objectleft + width * scaleX,
            opacity: 0,
          },
          {
            left: objectleft,
            opacity: opacity,
          },
        ],
      },
    },
  ];
};

export const getRevealInTopBaseKeyframe = (
  clipPathTop: number,
  height: number,
  objectTop: number,
  opacity: number,
  fabricObject: any,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: clipPathTop + height,
          },
          {
            top: clipPathTop,
          },
        ],
      },
      offset: REVEAL_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            top: objectTop - height * scaleY,
            opacity: 0,
          },
          {
            top: objectTop,
            opacity: opacity,
          },
        ],
      },
    },
  ];
};

export const getRevealInBottomBaseKeyframe = (
  height: number,
  objectTop: number,
  opacity: number,
  fabricObject: any,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: fabricObject.clipPath.top - height,
          },
          {
            top: fabricObject.clipPath.top,
          },
        ],
      },
      offset: REVEAL_OFFSET_BUFFER,
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            top: objectTop + height * scaleY,
            opacity: 0,
          },
          {
            top: objectTop,
            opacity: opacity,
          },
        ],
      },
    },
  ];
};

export const getRevealOutLeftBaseKeyframe = (
  clipPathleft: number,
  width: number,
  objectleft: number,
  opacity: number,
  fabricObject: any,
  scaleX: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: clipPathleft,
          },
          {
            left: clipPathleft + width,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            left: objectleft,
            opacity: opacity,
          },
          {
            left: objectleft - width * scaleX,
            opacity: 0,
          },
        ],
      },
    },
  ];
};

export const getRevealOutRightBaseKeyframe = (
  width: number,
  objectleft: number,
  opacity: number,
  fabricObject: any,
  scaleX: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            left: fabricObject.clipPath.left,
          },
          {
            left: fabricObject.clipPath.left - width,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            left: objectleft,
            opacity: opacity,
          },
          {
            left: objectleft + width * scaleX,
            opacity: 0,
          },
        ],
      },
    },
  ];
};

export const getRevealOutTopBaseKeyframe = (
  clipPathTop: number,
  height: number,
  objectTop: number,
  opacity: number,
  fabricObject: any,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: clipPathTop,
          },
          {
            top: clipPathTop + height,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            top: objectTop,
            opacity: opacity,
          },
          {
            top: objectTop - height * scaleY,
            opacity: 0,
          },
        ],
      },
    },
  ];
};

export const getRevealOutBottomBaseKeyframe = (
  height: number,
  objectTop: number,
  opacity: number,
  fabricObject: any,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject.clipPath,
        keyframes: [
          {
            top: fabricObject.clipPath.top,
          },
          {
            top: fabricObject.clipPath.top - height,
          },
        ],
      },
    },
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            top: objectTop,
            opacity: opacity,
          },
          {
            top: objectTop + height * scaleY,
            opacity: 0,
          },
        ],
      },
    },
  ];
};

export const getBeautifulQuestionsBaseKeyframe = (
  letterObjects: fabric.Object[],
  opacity: number,
  delay: number,
  duration: number,
  height: number
): KeyframeConfig[] => {
  return letterObjects.flatMap((letterObject: any, index: number) => {
    return [
      {
        option: {
          keyframes: [
            {
              top: letterObject.top + height,
              duration: 1,
              opacity: 0,
            },
            { top: letterObject.top, duration, opacity },
          ],
          targets: letterObject,
          delay: delay * (index + 1),
        },
      },
    ];
  });
};
